export default "__VITE_ASSET__Bid1IDsl__ 300w, __VITE_ASSET__D2Fy64Je__ 500w, __VITE_ASSET__BUuizgWE__ 800w";